import React, { useState } from 'react';

function ExpenseAdd({ onExpenseAdded, userId }) {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [date, setDate] = useState(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  });
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch('https://www.irsaliye.bybello.com/backend/api/expenses.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, amount, description, date })
    })
      .then(res => res.json())
      .then(() => {
        setMessage('Harcama eklendi!');
        if (onExpenseAdded) onExpenseAdded();
      })
      .catch(() => setMessage('Bir hata oluştu.'));
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ display: 'block', background: 'rgba(0,0,0,0.2)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Yeni Harcama Ekle</h5>
            <button type="button" className="btn-close" onClick={onExpenseAdded}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
            <div className="mb-3">
                <label className="form-label">Tutar</label>
                <input type="number" className="form-control" value={amount} onChange={e => setAmount(e.target.value)} required />
              </div>
              {amount !== '' && (
                <div className="mb-3">
                  <label className="form-label">Formatlı Tutar</label>
                  <p className="form-control-static">{parseFloat(amount).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 2 })}</p>
                </div>
              )}
              <div className="mb-3">
                <label className="form-label">Açıklama</label>
                <input type="text" className="form-control" value={description} onChange={e => setDescription(e.target.value)} required />
              </div>
              <div className="mb-3">
                <label className="form-label">Tarih</label>
                <input type="date" className="form-control" value={date} onChange={e => setDate(e.target.value)} required />
              </div>
              {message && <div className="alert alert-info">{message}</div>}
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">Ekle</button>
              <button type="button" className="btn btn-secondary" onClick={onExpenseAdded}>Kapat</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ExpenseAdd;
